export interface Badge {
  title: string
  description: string
}

export interface TrustBadgesTranslations {
  title: string
  subtitle: string
  badges: {
    certified: Badge
    experience: Badge
    reliable: Badge
    quality: Badge
    insurance: Badge
    healthSafety: Badge
    noHiddenCosts: Badge
    localExpertise: Badge
  }
}

export const trustBadgesTranslations: Record<'en' | 'cy', TrustBadgesTranslations> = {
  en: {
    title: 'Why Choose Me',
    subtitle: 'Professional garden services you can trust',
    badges: {
      certified: {
        title: 'Fully Certified',
        description: 'NPTC qualified with professional horticulture certifications'
      },
      experience: {
        title: '15+ Years Experience',
        description: 'Extensive knowledge in garden care and maintenance'
      },
      reliable: {
        title: 'Reliable Service',
        description: 'Consistent, punctual, and professional service every time'
      },
      quality: {
        title: 'Quality Guaranteed',
        description: 'We take pride in delivering exceptional results'
      },
      insurance: {
        title: 'Fully Insured',
        description: '£5M public liability, £10M employers liability for your peace of mind'
      },
      healthSafety: {
        title: 'Health & Safety Compliant',
        description: 'Comprehensive policies and regular risk assessments'
      },
      noHiddenCosts: {
        title: 'No Hidden Costs',
        description: 'Transparent pricing with no surprises'
      },
      localExpertise: {
        title: 'Local Expertise',
        description: 'Serving South Wales with 15+ years\' experience'
      }
    }
  },
  cy: {
    title: 'Pam Fy Dewis I',
    subtitle: 'Gwasanaethau gardd proffesiynol y gallwch ymddiried ynddynt',
    badges: {
      certified: {
        title: 'Ardystiedig yn Llawn',
        description: 'Cymwysterau NPTC gydag ardystiadau proffesiynol mewn garddwriaeth'
      },
      experience: {
        title: '15+ Mlynedd o Brofiad',
        description: 'Gwybodaeth helaeth mewn gofal a chynnal a chadw gardd'
      },
      reliable: {
        title: 'Gwasanaeth Dibynadwy',
        description: 'Gwasanaeth cyson, amserol a phroffesiynol bob tro'
      },
      quality: {
        title: 'Ansawdd Gwarantedig',
        description: 'Rwy\'n falch o gyflawni canlyniadau eithriadol'
      },
      insurance: {
        title: "Wedi'i Yswirio'n Llawn",
        description: '£5M atebolrwydd cyhoeddus, £10M atebolrwydd cyflogwr – tawelwch meddwl i chi'
      },
      healthSafety: {
        title: 'Cydymffurfio â Iechyd a Diogelwch',
        description: 'Polisïau cynhwysfawr ac asesiadau risg rheolaidd'
      },
      noHiddenCosts: {
        title: 'Dim Costau Cudd',
        description: 'Prisiau tryloyw, dim syrpreisiau'
      },
      localExpertise: {
        title: 'Arbenigedd Lleol',
        description: 'Yn gwasanaethu De Cymru gyda 15+ mlynedd o brofiad'
      }
    }
  }
} 